






















import Vue from 'vue';
import {Component, Prop} from 'vue-property-decorator';

@Component
export default class Calculator extends Vue {
    @Prop(Number) readonly value!: number;
    @Prop(Array) readonly tags!: object[];
    outPut: string = this.value.toString();

    inputContent(e: MouseEvent) {
        const button = e.target as HTMLButtonElement;
        const input = button.textContent as string;
        if (this.outPut.length >= 16) {
            return;
        }
        if (this.outPut === '0') {
            if ('0123456789'.indexOf(input) >= 0) {
                this.outPut = input;
                return;
            }
        }
        if (this.outPut.indexOf('.') >= 0 && input === '.') {
            return;
        }
        this.outPut += input;

    }

    remove() {
        if (this.outPut.length > 1) {
            this.outPut = this.outPut.slice(0, -1);
        } else {
            this.outPut = '0';
        }
    }

    clear() {
        this.outPut = '0';
    }

    save() {
        if (this.tags.length > 0){
            this.$emit('update:value', parseFloat(this.outPut));
            this.outPut = '0';
        }
        this.$emit('submit');

    }
}
